import React from "react";

function ProductTitle({ product }) {
  const originalPrice = parseFloat(product.priceRange.minVariantPrice.amount);
  // console.log(product)
  return (
    <div className="pt-4 text-center md:text-left heading-container">
      <h1 className="px-6 md:p-0 text-3xl">{product.title}</h1>
      <p className="mt-4 mb-1 font-bold">Rs. {originalPrice}</p>
      <p className="font-primaryFont text-[11px] tracking-wider">
        (incl. of all taxes)
      </p>
    </div>
  );
}

export default ProductTitle;

/*
old code 
<div className="pt-4 text-center md:text-left heading-container">
            <h1 className="px-6 md:p-0 text-3xl">{product.name}</h1>
            <p className="mt-4 mb-1 font-bold">Rs. {product.price}</p>
            <p className="font-primaryFont text-[11px] tracking-wider">
              (incl. of all taxes)
            </p>
          </div>
          */
